import { createApi } from "@reduxjs/toolkit/query/react";
import {
  CUSTOMER_TASK_DATA_GET,
  CUSTOMERTABLE_VALUE_UPDATE,
  CUSTOMER_TABLEDROP_DATA,
  ADD_UPDATE_DROPDOWN,
  CUSTOMER_OTHERDETAIL_DYNAMIC_ADD_UPDATE,
  BASE_URL,
  CUSTOMER_TASK_CATEGORY,
  CUSTOMER_CLOSED_TASK_GET,
  CUSTOMER_SOCIAL_DATA_GET,
  CUSTMOER_ARTIFACT_DATA_GET,
  GET_FOLDER,
  CUSTOMER_REPORTING_DATA_GET,
  CUSTOMERTABLE_TASK_VALUE_UPDATE,
  CUSTOMER_OVERDUSE_TASK_GET,
  CUSTOMER_CONTACT_DATA_GET,
  CUSTOMER_SINGLE_UPDATE_CONTACT_PERSON,
  CUSTOMER_TASK_GET_TASKPOD,
  CUSTOMER_ACTIVITY_GET_EVENT,
  CUSTOMER_SERVICE_DATA_GET,
  CUSTOMER_SERVICE_SINGLE_UPDATE,
  CUSTOMER_ARTIFACT_SINGLE_UPDATE,
  GET_COMPANY_ADDRRESS,
  SINGLE_UPDATE_SOCIAL_LINK,
  SINGLE_UPDATE_REPORTING_TEAM,
  CUSTOMER_ADDRESS_DATA_GET,
  CUSTOMER_ALL_ADDRESS,
  DELETE_CUSTOMER_ALL_ADDRESS,
  CUSTOMER_TASK_HEADER,
  COMPANY_PROFILE_DETAIL,
  CUSTOMER_ADDRESS_SINGLE_GET,
  CUSTMOER_NOTES_DATA_GET,
  CUSTOMER_GET_ALL_NOTES_DATA_BASEDON_SCROLL,
  CUSTOMER_GET_ALL_ACTIVITY_DATA_BASED_ON_SCROLL,
  USER_LIST_DATA,
  ADD_UPDATE_USER_LIST,
  MANAGE_LIST_GET,
  DYNAMIC_LIST_DATA,
  DYNAMIC_HEADER_LIST,
  EDITE_DYNAMIC_VALUE,
  GET_ALL_DATA_RELETED_TO_DESIGNATION,
  GET_COMPANY_DELEGETION,
  TASK_GET_ORGACCORDING,
  GET_ALL_CUSTOMER_DELEGATION,
  GET_ALL_ADDRESS_COMPANY,
  EDIT_COMPANY_ADDRESS_BASED_ON_ID,
  GET_VENDOR_LIST,
  GET_SOCIAL_LINK_VENDOR,
  GET_VENDOR_CONTACT_DATA,
  SINGLE_VENDOR_ADD_UPDATE_CONTACT_DATA,
  GET_VENDOR_ALL_ADDRESS,
  EDIT_VENDOR_ADDRESS,
  GET_CUSTOMER_GROUP_DATA_ADD_UPDATE_TIME,
  ENABLE_USER,
  DELETE_TABLE_CATEGORIES_DATA,
  DELETE_EXTERNAL_USER,
  GET_ALL_CUSTOMER_DELEGATION_RIGHT,
  CUSTOMER_TASK_GET_ALL_CUSTOMER,
  CUSTOMER_TASK_DELETE,
  GET_CUSTOMER_GROUP_DATA_ADD_UPDATE_TIME1,
  GET_ALL_TASKPODS,
  DELETE_SERVICE_DATA,
  CONFIG_SERVICE,
  GET_ALL_ORG_SERVICE,
  ADD_UPDATE_ORG_SERVICE,
  ADD_UPDATE_CUSTOMER_SERVICE,
  GET_ALL_PROJECTS,
  GET_SINGLE_PROJECT,
  CREATE_UPDATE_PROJECTS,
  CREATE_PROJECT_JOB,
  GET_PROJECT_TASK_ENUM_VALUES,
  GET_ALL_SERVICES,
  DELETE_SUB_SERVICE,
  UPDATE_TASK_COMPLETION,
  CUSTMOER_NOTES_DATA_DELETE,
  GET_TASK_TAGS,
  CUSTOMER_PROJECT_DELETE,
  CUSTOMER_TASK_HEADER_CONFIG,
  EDIT_USER_LIST_BASED_ON_ID,
  GET_COMPANY_LIST_GROUPS,
  GET_GROUP_DATA,
  POST_ADD_UPDATE_MANAGE_LIST,
  GET_MANAGE_LIST,
  DELETE_MANAGE_LIST,
  GET_HEADERS_BY_ROW_ID_MANAGE_FIELDS,
  GET_VALUES_BY_ROW_ID_MANAGE_FIELDS,
  POST_ADD_FIELD_MANAGE_FIELDS,
  POST_ADD_VALUE_MANAGE_FIELDS,
  DELETE_ROW_VALUE,
  DELETE_COLUMN_FIELDS,
  CUSTOMER_ADD_NOTES_ATTACHMENT,
  CUSTOMER_DELETE_NOTES_ATTACHMENT,
  VENDOR_REST_API,
  GET_DROPDOWN_GROUPS_AND_VALUES,
  GET_VENDOR_HEADER_CONFIGURATION,
  GET_VENDOR_HEADER_CONFIGURATION_VALUES,
  GET_COMPANY_DELEGATION_New,
  GET_COMPANY_DELEGATION_NEW,
  CREATE_OR_UPDATE_USER,
  DELETE_USER,
  GET_CUS_DASH_DATA,
  TASK_LINKING,
  LINK_TASK_TO_NOTES,
} from "../constants";
import { fetchVendorSocail } from "../vendor/vendorSocialSlice";
import customBaseQuery from "../CustomBaseQuery/customBaseQuery";
import { getCompanyId, getOrganizationId, getUserId, getUserToken } from "../utilityFunctions/localServices";
import { useFetchCompanyListQuery } from "../company/companySelector";

export const customerTaskTableShowUpdate = createApi({
  reducerPath: "customerTaskTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    // fetchCustomerTaskTableData: builder.query({
    //   query: ({ token, customerId, pagination, status,quiFilter }) => {
    //     let url = `${CUSTOMER_TASK_DATA_GET}${customerId}?status=${status}&quiFilter=${encodeURIComponent(quiFilter)}&${pagination}`;
    //     return {
    //       url,
    //       method: 'GET',
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //         'Content-Type': 'application/json',
    //       },
    //     };
    //   },
    // }),

    fetchCustomerTaskTableData: builder.query({
      query: ({ token, customerId, owner, company_id, pagination, status, quiFilter }) => {
        const params = new URLSearchParams({
          status,
          quiFilter: encodeURIComponent(quiFilter),
          ...pagination,
        });

        const url = `${CUSTOMER_TASK_DATA_GET}${customerId}?${params.toString()}&owner=${owner}&company_id=${company_id}`;
        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
    updateCustomerTaskTableData: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMERTABLE_TASK_VALUE_UPDATE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});

export const { useFetchCustomerTaskTableDataQuery, useUpdateCustomerTaskTableDataMutation } =
  customerTaskTableShowUpdate;

export const TaskGetOrgAccording = createApi({
  reducerPath: "TaskGetOrgAccording",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchTaskGetOrgAccording: builder.query({
      query: ({ token, customerId, owner, company_id, pagination, status, quiFilter, paginate }) => {
        const params = new URLSearchParams({
          status,
          quiFilter: encodeURIComponent(quiFilter),
          ...pagination,
        });

        const queryParams = [
          customerId ? `customer_id=${customerId}` : "",
          owner ? `owner=${owner}` : "",
          company_id ? `company_id=${company_id}` : "",
          paginate ? `paginate=${paginate}` : "",
          pagination ? pagination : "",
        ];

        const queryString = queryParams.filter(Boolean).join("&");

        const url = `${TASK_GET_ORGACCORDING}?${queryString}`;
        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
  }),
});

export const { useFetchTaskGetOrgAccordingQuery } = TaskGetOrgAccording;

export const customerDocumentUpdate = createApi({
  reducerPath: "customerDocumentUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerDocumentData: builder.query({
      query: ({
        token,
        customerId,
        folderId,
        userId,
        companyId,
        orgId,
        type = "Tracking",
        templateId,
        row_id,
        core_id,
      }) => ({
        url: `${GET_FOLDER}?folderId=${folderId}&orgId=${orgId}&userId=${userId}&companyId=${companyId}&customerId=${customerId}&${templateId ? `template_id=${templateId}` : `type=${type}`}${row_id ? `&row_id=${row_id}` : ""}${core_id ? `&core_id=${core_id}` : ""}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),

    updateCustomerDocumentData: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMER_ARTIFACT_SINGLE_UPDATE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});

export const {
  useFetchCustomerDocumentDataQuery,
  useLazyFetchCustomerDocumentDataQuery,
  useUpdateCustomerDocumentDataMutation,
} = customerDocumentUpdate;

export const customerReportingTeamUpdate = createApi({
  reducerPath: "customerReportingTeamUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerReportingData: builder.query({
      query: ({ token, customerId, pagination }) => ({
        url: `${CUSTOMER_REPORTING_DATA_GET}${customerId}${pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    updateCustomerReportingData: builder.mutation({
      query: ({ token, data }) => ({
        url: SINGLE_UPDATE_REPORTING_TEAM,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),

    fetchLinkingData: builder.query({
      query: ({ taskId }) => ({
        url: `${TASK_LINKING}${taskId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const {
  useFetchCustomerReportingDataQuery,
  useUpdateCustomerReportingDataMutation,
  useLazyFetchLinkingDataQuery,
} = customerReportingTeamUpdate;

export const customerSocialShowUpdate = createApi({
  reducerPath: "customerSocialShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerSocialData: builder.query({
      query: ({ token, customerId, pagination }) => ({
        url: `${CUSTOMER_SOCIAL_DATA_GET}${customerId}${pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    updateCustomerSocialData: builder.mutation({
      query: ({ token, data }) => ({
        url: SINGLE_UPDATE_SOCIAL_LINK,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});

export const { useFetchCustomerSocialDataQuery, useUpdateCustomerSocialDataMutation } = customerSocialShowUpdate;

export const customerTaskTableDropAdd = createApi({
  reducerPath: "customerTaskTableDropAdd",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerTaskTable: builder.query({
      query: ({ token }) => ({
        url: CUSTOMER_TASK_CATEGORY,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    CustomerTaskTableDropAdd: builder.mutation({
      query: ({ token, data }) => ({
        url: ADD_UPDATE_DROPDOWN,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});
export const { useLazyFetchCustomerTaskTableQuery, useCustomerTaskTableDropAddMutation } = customerTaskTableDropAdd;

export const custTableHeadFieldDynAddUp = createApi({
  reducerPath: "custTableHeadFieldDynAddUp",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    CustTableHeadFieldDyn: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMER_OTHERDETAIL_DYNAMIC_ADD_UPDATE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});

export const { useCustTableHeadFieldDynMutation } = custTableHeadFieldDynAddUp;

// export const customerTaskOverTableShowUpdate = createApi({
//   reducerPath: 'customerTaskOverTableShowUpdate',
//   baseQuery: customBaseQuery,
//   endpoints: (builder) => ({
//     fetchCustomerTaskOverTableData: builder.query({
//       query: ({ token, customerId, pagination }) => ({
//         url: `${CUSTOMER_TASK_Over_DATA_GET}${customerId}?${pagination}`,
//         method: 'GET',
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       }),
//     }),
//     updateCustomerTaskOverTableData: builder.mutation({
//       query: ({ token, data }) => ({
//         url: CUSTOMERTABLE_TASK_VALUE_UPDATE,
//         method: 'POST',
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//         body: data,
//       }),
//     }),
//   }),
// });

// export const {
//   useFetchCustomerTaskOverTableDataQuery,
//   useUpdateCustomerTaskOverTableDataMutation,
// } = customerTaskOverTableShowUpdate;

export const customerTaskDueTableShowUpdate = createApi({
  reducerPath: "customerTaskDueTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerTaskDueTableData: builder.query({
      query: ({ token, customerId, pagination }) => ({
        url: `${CUSTOMER_OVERDUSE_TASK_GET}${customerId}${pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    updateCustomerTaskDueTableData: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMERTABLE_TASK_VALUE_UPDATE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});

export const { useFetchCustomerTaskDueTableDataQuery, useUpdateCustomerTaskDueTableDataMutation } =
  customerTaskDueTableShowUpdate;

export const customerTaskCloseTableShowUpdate = createApi({
  reducerPath: "customerTaskCloseTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerTaskCloseTableData: builder.query({
      query: ({ token, customerId, pagination }) => ({
        url: `${CUSTOMER_CLOSED_TASK_GET}${customerId}${pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchCustomerTaskCloseTableDataQuery } = customerTaskCloseTableShowUpdate;

export const customerContactTableShowUpdate = createApi({
  reducerPath: "customerContactTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerContactTableData: builder.query({
      query: ({ token, customerId, pagination }) => ({
        url: `${CUSTOMER_CONTACT_DATA_GET}${customerId}${pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    updateCustomerContactTableData: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMER_SINGLE_UPDATE_CONTACT_PERSON,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});

export const { useFetchCustomerContactTableDataQuery, useUpdateCustomerContactTableDataMutation } =
  customerContactTableShowUpdate;

export const customerTaskPodTableShowUpdate = createApi({
  reducerPath: "customerTaskPodTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    // fetchCustomerTaskPodTableData: builder.query({
    //   query: ({ token, task_pod, company_id, customer_id, pagination, quiFilter, assign_id, filter_tab }) => ({
    //     url: `${CUSTOMER_TASK_GET_TASKPOD}?${pagination}&limit=20`,
    //     method: "POST",
    //     headers: {
    //       Authorization: `Bearer ${token?.token}`,
    //       "Content-Type": "application/json",
    //     },
    //     body: {
    //       task_pod: task_pod,
    //       company_id: company_id?.company_id,
    //       org_id: token?.org_id,
    //       assign_id: assign_id,
    //       user_id: token?.user_id,
    //       filter_tab: filter_tab,
    //       per_page: pagination?.per_page,
    //       customer_id: customer_id,
    //     },
    //   }),
    //   keepUnusedDataFor: 0, // Disables caching
    //   refetchOnMountOrArgChange: true,
    // }),
    fetchCustomerTaskPodTableData: builder.query({
      query: ({
        token,
        task_pod,
        company_id,
        customer_id,
        pagination,
        quiFilter,
        assign_id,
        filter_tab,
        group_by_fields,
        get_project,
        category_filter,
        visibility_status,
      }) => {
        console.log(token, task_pod, company_id, customer_id, pagination, quiFilter, assign_id, filter_tab, "pagin421");
        // Parse the pagination string
        const params = new URLSearchParams(pagination);
        const perPage = params.get("per_page") || 20; // Default to 20 if per_page is not present
        const Page = params.get("page") || 1;
        // console.log(Page, "page");
        console.log(
          {
            task_pod: task_pod,
            company_id: company_id?.company_id,
            org_id: token?.org_id,
            assign_id: assign_id,
            user_id: token?.user_id,
            filter_tab: filter_tab,
            per_page: perPage, // Use extracted per_page value
            customer_id: customer_id,
            quick_filter_type: quiFilter,
            group_by_fields: group_by_fields,
          },
          "vikaa test"
        );

        return {
          url: `${CUSTOMER_TASK_GET_TASKPOD}?per_page=${perPage}&page=${Page}`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token?.token}`,
            "Content-Type": "application/json",
          },
          body: {
            task_pod: task_pod,
            company_id: company_id?.company_id,
            org_id: token?.org_id,
            assign_id: assign_id,
            user_id: token?.user_id,
            filter_tab: filter_tab,
            per_page: perPage, // Use extracted per_page value
            customer_id: customer_id,
            quick_filter_type: quiFilter,
            group_by_fields: group_by_fields,
            get_project: get_project,
            category_filter: category_filter,
            visibility_status: visibility_status,
          },
        };
      },
      keepUnusedDataFor: 0, // Disables caching
      refetchOnMountOrArgChange: true,
    }),
    fetchTaskHeaderConfiguration: builder.query({
      query: ({ entity, customer_id }) => {
        return {
          url: `${CUSTOMER_TASK_HEADER_CONFIG}?entity=${entity}&customer_id=${customer_id}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
      keepUnusedDataFor: 0, // Disables caching
      refetchOnMountOrArgChange: true,
    }),
    fetchCustomerTaskPodAllCustomerData: builder.query({
      query: ({ search }) => ({
        url: `${CUSTOMER_TASK_GET_ALL_CUSTOMER}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: {
          company_id: getCompanyId(),
          org_id: getOrganizationId(),
          user_id: getUserId(),
          search: search,
        },
      }),
    }),
    updateCustomerTaskPodTableData: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMERTABLE_TASK_VALUE_UPDATE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
    updateTaskCompletion: builder.mutation({
      query: ({ data }) => ({
        url: UPDATE_TASK_COMPLETION,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
    deleteTask: builder.mutation({
      query: ({ token, data, delete_options }) => {
        const isSubTask = Boolean(data?.parent_task_id);
        const company_id = data?.company_id;
        return {
          url: `${CUSTOMER_TASK_DELETE}/${data?.id}/delete`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: {
            is_sub_task: isSubTask,
            company_id: company_id,
            delete_options: delete_options,
          },
        };
      },
    }),
    deleteProject: builder.mutation({
      query: ({ token, data }) => {
        return {
          url: `${CUSTOMER_PROJECT_DELETE}/delete/${data?.project_id}`,
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          // body: {
          //   is_sub_task: isSubTask,
          //   company_id: company_id,
          // },
        };
      },
    }),
    fetchAllTaskPods: builder.query({
      query: ({ type, customerId }) => ({
        url: `${GET_ALL_TASKPODS}?type=${type}&customer_id=${customerId}&company_id=${getCompanyId()}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),
    // /project/fetch/all?customer_id=12
    fetchAllProjects: builder.query({
      query: ({ customerId }) => ({
        url: `${GET_ALL_PROJECTS}?customer_id=${customerId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),

    createUpdateProject: builder.mutation({
      query: ({ data }) => ({
        url: `${CREATE_UPDATE_PROJECTS}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),

    fetchSingleProject: builder.query({
      query: ({ projectId }) => ({
        url: `${GET_SINGLE_PROJECT}/${projectId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),

    createJob: builder.mutation({
      query: ({ payload }) => ({
        url: `${CREATE_PROJECT_JOB}`,
        method: "POST",
        body: payload,
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          // "Content-Type": "application/json",
        },
      }),
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),
    LinkTask: builder.mutation({
      query: ({ payload }) => ({
        url: `${LINK_TASK_TO_NOTES}?template_id=undefined&row_id=null`,
        method: "POST",
        body: payload,
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          // "Content-Type": "application/json",
        },
      }),
    }),
    getProjectTaskEnum: builder.query({
      query: ({ payload }) => ({
        url: `${GET_PROJECT_TASK_ENUM_VALUES}?entity=${payload?.entity}&field=${payload?.field}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),
    getTaskTags: builder.query({
      query: ({ payload }) => ({
        url: `${GET_TASK_TAGS}/${getCompanyId()}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
      // providesTags: ["getTags"],
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),
    postTaskTags: builder.mutation({
      query: ({ payload }) => ({
        url: `${GET_TASK_TAGS}/${getCompanyId()}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload,
      }),
      // invalidatesTags: ["getTags"],
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),

    fetchServiceList: builder.query({
      query: ({ payload }) => ({
        url: `${GET_ALL_SERVICES}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useFetchCustomerTaskPodTableDataQuery,
  useFetchCustomerTaskPodAllCustomerDataQuery,
  useUpdateCustomerTaskPodTableDataMutation,
  useDeleteTaskMutation,
  useFetchAllTaskPodsQuery,
  useLazyFetchAllProjectsQuery,
  useCreateUpdateProjectMutation,
  useFetchSingleProjectQuery,
  useCreateJobMutation,
  useLinkTaskMutation,
  useLazyGetProjectTaskEnumQuery,
  useLazyGetTaskTagsQuery,
  useGetTaskTagsQuery,
  usePostTaskTagsMutation,
  useLazyFetchServiceListQuery,
  useUpdateTaskCompletionMutation,
  useDeleteProjectMutation,
  useFetchTaskHeaderConfigurationQuery,
} = customerTaskPodTableShowUpdate;

export const customerTaskActivityCount = createApi({
  reducerPath: "customerTaskActivityCount",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerTaskActivityCount: builder.query({
      query: ({ token, taskId }) => ({
        url: `${CUSTOMER_ACTIVITY_GET_EVENT}?task_id=${encodeURIComponent(taskId)}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchCustomerTaskActivityCountQuery } = customerTaskActivityCount;

export const customerServiceTableShowUpdate = createApi({
  reducerPath: "customerServiceTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getCustomerServices: builder.query({
      query: ({ token, customerId }) => ({
        url: `${CUSTOMER_SERVICE_DATA_GET}?customer_id=${customerId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    addUpdateCustomerService: builder.mutation({
      query: ({ token, CustomerServicePayload }) => ({
        url: ADD_UPDATE_CUSTOMER_SERVICE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: CustomerServicePayload,
      }),
    }),
    deleteService: builder.mutation({
      query: ({ id, token }) => ({
        url: `${DELETE_SERVICE_DATA}/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        invalidatesTags: ["Get"],
      }),
    }),

    deleteSubService: builder.mutation({
      query: ({ subServicePayload, token }) => ({
        url: `${DELETE_SUB_SERVICE}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: subServicePayload,
      }),
    }),

    addupdateOrgServices: builder.mutation({
      query: ({ servicePayload, token }) => ({
        url: ADD_UPDATE_ORG_SERVICE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: servicePayload,
      }),
    }),
    getOrgServices: builder.query({
      query: ({ token }) => ({
        url: `${GET_ALL_ORG_SERVICE}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const {
  useGetCustomerServicesQuery,
  useDeleteServiceMutation,
  useGetOrgServicesQuery,
  useAddupdateOrgServicesMutation,
  useAddUpdateCustomerServiceMutation,
  useDeleteSubServiceMutation,
} = customerServiceTableShowUpdate;

export const companyTableShowUpdate = createApi({
  reducerPath: "companyTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCompanyTableData: builder.query({
      query: ({ token, customerId, pagination }) => ({
        url: `${GET_COMPANY_ADDRRESS}${customerId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchCompanyTableDataQuery } = companyTableShowUpdate;

export const customerAddressTableShowUpdate = createApi({
  reducerPath: "customerAddressTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerAddressTableData: builder.query({
      query: ({ token, customerId, pagination }) => ({
        url: `${CUSTOMER_ADDRESS_DATA_GET}${customerId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchCustomerAddressTableDataQuery } = customerAddressTableShowUpdate;

export const customerAllAddressTableShowUpdate = createApi({
  reducerPath: "customerAllAddressTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerAllAddressTableData: builder.query({
      query: ({ token, customerId, pagination }) => ({
        // url: `${CUSTOMER_ALL_ADDRESS}${customerId}${pagination}`,
        url: `${CUSTOMER_ALL_ADDRESS}${customerId}${pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["Get"],
    }),
    updateCustomerAllAddressTableData: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMER_ALL_ADDRESS,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
    deleteCustomerAllAddressTableData: builder.mutation({
      query: ({ token, data }) => ({
        url: DELETE_CUSTOMER_ALL_ADDRESS,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
      invalidatesTags: ["Get"],
    }),
  }),
});

export const {
  useFetchCustomerAllAddressTableDataQuery,
  useUpdateCustomerAllAddressTableDataMutation,
  useDeleteCustomerAllAddressTableDataMutation,
} = customerAllAddressTableShowUpdate;

export const customerTaskHeaderApi = createApi({
  reducerPath: "customerTaskHeaderApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerHeaderTask: builder.query({
      query: ({ token }) => ({
        url: `${CUSTOMER_TASK_HEADER}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchCustomerHeaderTaskQuery } = customerTaskHeaderApi;

export const customerCompanyDataApi = createApi({
  reducerPath: "customerCompanyDataApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerCompanyData: builder.query({
      query: ({ token, company_profile_id }) => ({
        url: `${COMPANY_PROFILE_DETAIL}?profile_id=${encodeURIComponent(company_profile_id)}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchCustomerCompanyDataQuery } = customerCompanyDataApi;

export const customerAddressSingleDataApi = createApi({
  reducerPath: "customerAddressSingleDataApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerAddressSingle: builder.query({
      query: ({ token, addressId }) => ({
        url: `${CUSTOMER_ADDRESS_SINGLE_GET}${addressId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchCustomerAddressSingleQuery } = customerAddressSingleDataApi;

export const customerNotesTableDataApi = createApi({
  reducerPath: "customerNotesTableDataApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerNotesTableData: builder.query({
      query: ({ customerId, limit = 100, page = 1, type = "Tracking", template_id = null, row_id, sort }) => ({
        url: `${CUSTMOER_NOTES_DATA_GET}${customerId}?limit=${limit}&page=${page}&sort=${sort}&${template_id ? `template_id=${template_id}` : `type=${type}`} ${row_id ? `&row_id=${row_id}` : ""}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),

    postApi: builder.mutation({
      query: ({ data, url }) => ({
        url: `${url}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
        },
        body: data,
      }),
    }),
    putApi: builder.mutation({
      query: ({ data, url }) => ({
        url: `${url}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
        },
        body: data,
      }),
    }),

    DeleteNote: builder.mutation({
      query: (id) => ({
        url: `${CUSTMOER_NOTES_DATA_DELETE}${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),

    postNoteAttachment: builder.mutation({
      query: ({ data }) => ({
        url: CUSTOMER_ADD_NOTES_ATTACHMENT,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
        },
        body: data,
      }),
    }),
    deleteNoteAttachment: builder.mutation({
      query: ({ id }) => ({
        url: `${CUSTOMER_DELETE_NOTES_ATTACHMENT}${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
        },
      }),
    }),
  }),
});

export const {
  useFetchCustomerNotesTableDataQuery,
  useLazyFetchCustomerNotesTableDataQuery,
  usePostApiMutation,
  usePutApiMutation,
  useFetchSectionCompanyDataQuery,
  useDeleteNoteMutation,
  usePostNoteAttachmentMutation,
  useDeleteNoteAttachmentMutation,
} = customerNotesTableDataApi;

export const customerNotesDataTableShowUpdate = createApi({
  reducerPath: "customerNotesDataTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerNotesDataTableData: builder.query({
      query: ({ token, customerId, page, quiFilter }) => ({
        url: `${CUSTOMER_GET_ALL_NOTES_DATA_BASEDON_SCROLL}${customerId}?page=${page}&quiFilter=${quiFilter}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchCustomerNotesDataTableDataQuery } = customerNotesDataTableShowUpdate;

export const customerActivityDataTableShowUpdate = createApi({
  reducerPath: "customerActivityDataTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerActivityDataTableData: builder.query({
      query: ({ token, taskid, page }) => ({
        url: `${CUSTOMER_GET_ALL_ACTIVITY_DATA_BASED_ON_SCROLL}${taskid}?page=${page}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchCustomerActivityDataTableDataQuery } = customerActivityDataTableShowUpdate;

export const userDataTableShowUpdate = createApi({
  reducerPath: "userDataTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchUserDataTableData: builder.query({
      query: ({ token, pagination, quiFilter }) => ({
        url: `${USER_LIST_DATA}?${pagination}&${new URLSearchParams(quiFilter).toString()}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["GET"],
    }),
    AddUpdateUserList: builder.mutation({
      query: ({ token, data }) => ({
        url: ADD_UPDATE_USER_LIST,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
    UpdateUserActive: builder.mutation({
      query: ({ token, data }) => {
        return {
          url: `${ENABLE_USER}/?user_id=${data}`,

          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: data,
        };
      },
      invalidatesTags: ["GET"],
    }),

    //post to get updateUserActive
    UpdateUserActiveGet: builder.query({
      query: ({ token, data }) => {
        return {
          url: `${ENABLE_USER}?user_id=${data}`,

          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
      invalidatesTags: ["GET"],
    }),

    DeleteExternalUser: builder.mutation({
      query: ({ token, data }) => ({
        url: DELETE_EXTERNAL_USER,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
      invalidatesTags: ["GET"],
    }),

    fetchEditUserData: builder.query({
      query: ({ uuid, token }) => ({
        url: `${EDIT_USER_LIST_BASED_ON_ID}?uuid=${uuid}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    fetchCompanyListData: builder.query({
      query: ({ token }) => ({
        url: `${GET_COMPANY_LIST_GROUPS}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    getCommonDataBasedOnId: builder.query({
      query: ({ token }) => ({
        url: `${GET_GROUP_DATA}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["GroupData"],
    }),

    CreateOrUpdateUser: builder.mutation({
      query: ({ token, data }) => ({
        url: CREATE_OR_UPDATE_USER,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),

    DeleteUser: builder.mutation({
      query: ({ token, data }) => ({
        url: DELETE_USER,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});

export const {
  useAddUpdateUserListMutation,
  useFetchUserDataTableDataQuery,
  useUpdateUserActiveMutation,
  useLazyUpdateUserActiveGetQuery,
  useDeleteExternalUserMutation,
  useFetchEditUserDataQuery,
  useLazyFetchEditUserDataQuery,
  useFetchCompanyListDataQuery,
  useGetCommonDataBasedOnIdQuery,
  useCreateOrUpdateUserMutation,
  useDeleteUserMutation,
} = userDataTableShowUpdate;

export const manageListApi = createApi({
  reducerPath: "manageListApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchManageListData: builder.query({
      query: ({ token, pagination }) => ({
        url: `${GET_MANAGE_LIST}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    AddUpdateManageList: builder.mutation({
      query: ({ token, payload }) => ({
        url: POST_ADD_UPDATE_MANAGE_LIST,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: payload,
      }),
    }),
    DeleteManageList: builder.mutation({
      query: ({ token, payload }) => ({
        url: `${DELETE_MANAGE_LIST}/${payload}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    fetchHeadersByRowId: builder.mutation({
      query: ({ token, rowId }) => ({
        url: `${GET_HEADERS_BY_ROW_ID_MANAGE_FIELDS}/${rowId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    fetchValuesByRowId: builder.mutation({
      query: ({ token, rowId }) => ({
        url: `${GET_VALUES_BY_ROW_ID_MANAGE_FIELDS}/${rowId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    addFieldsInManageList: builder.mutation({
      query: ({ token, payload, tableId }) => ({
        url: `${POST_ADD_FIELD_MANAGE_FIELDS}/${tableId}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: payload,
      }),
    }),
    addValueInManageList: builder.mutation({
      query: ({ token, payload, tableId }) => ({
        url: `${POST_ADD_VALUE_MANAGE_FIELDS}/${tableId}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: payload,
      }),
    }),
    DeleteTableRow: builder.mutation({
      query: ({ token, tableId, rowId }) => ({
        url: `${DELETE_ROW_VALUE}/${tableId}/${rowId}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    DeleteTableColumn: builder.mutation({
      query: ({ token, tableId, columnId }) => ({
        url: `${DELETE_COLUMN_FIELDS}/${tableId}/${columnId}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const {
  useFetchManageListDataQuery,
  useLazyFetchManageListDataQuery,
  useAddUpdateManageListMutation,
  useDeleteManageListMutation,
  useFetchHeadersByRowIdMutation,
  useFetchValuesByRowIdMutation,
  useAddFieldsInManageListMutation,
  useAddValueInManageListMutation,
  useDeleteTableRowMutation,
  useDeleteTableColumnMutation,
} = manageListApi;

export const dynamicDataTableShowUpdate = createApi({
  reducerPath: "dynamicDataTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchDynamicDataTableData: builder.query({
      query: ({ uuid, token }) => {
        const url = `${DYNAMIC_LIST_DATA}?uuid=${uuid}`;
        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
      providesTags: ["GetDynamicData"],
    }),
    updateDynamicDataTableData: builder.mutation({
      query: ({ token, data }) => {
        const url = `${DELETE_TABLE_CATEGORIES_DATA}`;
        return {
          url,
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: data,
        };
      },
      invalidatesTags: ["GetDynamicData"],
    }),
  }),
});

export const {
  useFetchDynamicDataTableDataQuery,
  useLazyFetchDynamicDataTableDataQuery,
  useUpdateDynamicDataTableDataMutation,
} = dynamicDataTableShowUpdate;

export const dynamicHeader = createApi({
  reducerPath: "dynamicHeader",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchDynamicHeader: builder.query({
      query: ({ token, dynamicId, Pagination }) => ({
        url: `${DYNAMIC_HEADER_LIST}?${dynamicId}${Pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchDynamicHeaderQuery } = dynamicHeader;

export const dynamicEditValue = createApi({
  reducerPath: "dynamicEditValue",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchDynamicEditValue: builder.query({
      query: ({ token, id, getId }) => ({
        url: `${EDITE_DYNAMIC_VALUE}${id}?getId=${getId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    // AddUpdateManageList: builder.mutation({
    //   query: ({ token, payload }) => ({
    //     url: POST_ADD_UPDATE_MANAGE_LIST,
    //     method: "POST",
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //       "Content-Type": "application/json",
    //     },
    //     body: payload,
    //   }),
    // }),
    //   DeleteManageList: builder.mutation({
    //   query: ({ token, payload }) => ({
    //     url: `${DELETE_MANAGE_LIST}/${payload}`,
    //     method: "DELETE",
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //       "Content-Type": "application/json",
    //     },
    //   }),
    // }),
  }),
});

export const { useFetchDynamicEditValueQuery } = dynamicEditValue;

export const getAllData = createApi({
  reducerPath: "getAllData",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchGetAllData: builder.query({
      query: ({ token }) => ({
        url: `${GET_ALL_DATA_RELETED_TO_DESIGNATION}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchGetAllDataQuery } = getAllData;

export const companyDelegation = createApi({
  reducerPath: "companyDelegation",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCompanyDelegation: builder.query({
      query: ({ token, pagination }) => ({
        url: `${GET_COMPANY_DELEGETION}${pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    fetchCustomerDelegationNew: builder.query({
      query: ({ token, customerId }) => ({
        url: `${GET_COMPANY_DELEGATION_NEW}/${customerId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    updateCompanyDelegation: builder.mutation({
      query: ({ token, data }) => ({
        url: ADD_UPDATE_DROPDOWN,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});
export const {
  useFetchCompanyDelegationQuery,
  useFetchCustomerDelegationNewQuery,
  useUpdateCompanyDelegationMutation,
} = companyDelegation;

export const customerDelegation = createApi({
  reducerPath: "customerDelegation",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerDelegation: builder.query({
      query: ({ token, pagination }) => ({
        url: `${GET_COMPANY_DELEGETION}${pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    updateCustomerDelegation: builder.mutation({
      query: ({ token, data }) => ({
        url: ADD_UPDATE_DROPDOWN,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});
export const { useFetchCustomerDelegationQuery, useLazyFetchCustomerDelegationQuery } = customerDelegation;

export const customerTableDelegation = createApi({
  reducerPath: "customerTableDelegation",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerTableDelegation: builder.query({
      query: ({ token, pagination, customerId, rightTabFLag }) => ({
        url: rightTabFLag
          ? GET_ALL_CUSTOMER_DELEGATION_RIGHT
          : `${GET_ALL_CUSTOMER_DELEGATION}${customerId}${pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});
export const { useFetchCustomerTableDelegationQuery, useLazyFetchCustomerTableDelegationQuery } =
  customerTableDelegation;

export const companyAddressSingleDataApi = createApi({
  reducerPath: "companyAddressSingleDataApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCompanyAddressSingle: builder.query({
      query: ({ token, addressId }) => ({
        url: `${EDIT_COMPANY_ADDRESS_BASED_ON_ID}${addressId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchCompanyAddressSingleQuery } = companyAddressSingleDataApi;

export const companyAddressTableShowUpdate = createApi({
  reducerPath: "companyAddressTableShowUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCompanyAddressTableData: builder.query({
      query: ({ token, companyId, pagination }) => ({
        url: `${GET_ALL_ADDRESS_COMPANY}${companyId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchCompanyAddressTableDataQuery } = companyAddressTableShowUpdate;

export const vendorList = createApi({
  reducerPath: "vendorList",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchVendorList: builder.query({
      query: ({ token, companyId, pagination }) => ({
        url: `${GET_VENDOR_LIST}${companyId}${pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    updateVendorSingle: builder.mutation({
      query: ({ token, data }) => ({
        url: SINGLE_UPDATE_REPORTING_TEAM,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});

export const { useFetchVendorListQuery, useUpdateVendorSingleMutation } = vendorList;

export const vendorSocial = createApi({
  reducerPath: "vendorSocial",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchVendorSocail: builder.query({
      query: ({ token, vendorId, pagination }) => ({
        url: `${GET_SOCIAL_LINK_VENDOR}${vendorId}${pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    updateVendorSocail: builder.mutation({
      query: ({ token, data }) => ({
        url: SINGLE_UPDATE_SOCIAL_LINK,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});

export const { useFetchVendorSocailQuery, useUpdateVendorSocailMutation } = vendorSocial;

export const vendorContact = createApi({
  reducerPath: "vendorContact",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchVendorContact: builder.query({
      query: ({ token, vendorId, pagination }) => ({
        url: `${GET_VENDOR_CONTACT_DATA}${vendorId}${pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    updateVendorContact: builder.mutation({
      query: ({ token, data }) => ({
        url: SINGLE_VENDOR_ADD_UPDATE_CONTACT_DATA,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});

export const { useFetchVendorContactQuery, useUpdateVendorContactMutation } = vendorContact;

export const vendorAllAddress = createApi({
  reducerPath: "vendorAllAddress",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchVendorAllAddress: builder.query({
      query: ({ token, vendorId, pagination }) => ({
        url: `${GET_VENDOR_ALL_ADDRESS}${vendorId}${pagination}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchVendorAllAddressQuery } = vendorAllAddress;

export const editVendorAddress = createApi({
  reducerPath: "editVendorAddress",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchEditVendorAddress: builder.query({
      query: ({ token, addressId }) => ({
        url: `${EDIT_VENDOR_ADDRESS}${addressId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useFetchEditVendorAddressQuery } = editVendorAddress;

export const VendorsAPI = createApi({
  reducerPath: "VendorsAPI",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    // GET Vendor By ID
    getVendorById: builder.query({
      query: ({ UUID, token }) => ({
        url: `${VENDOR_REST_API}/${UUID}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),

    // GET General Info
    getGeneralInfo: builder.query({
      query: ({ UUID, token }) => ({
        url: `${VENDOR_REST_API}/${UUID}/general-info`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    // POST General Info
    postGeneralInfo: builder.mutation({
      query: ({ token, formData }) => ({
        url: `${VENDOR_REST_API}`,
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    // GET Address
    getAddress: builder.query({
      query: ({ UUID, token }) => ({
        url: `${VENDOR_REST_API}/${UUID}/address`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    // POST Address
    postAddress: builder.mutation({
      query: ({ UUID, token, body }) => ({
        url: `${VENDOR_REST_API}/${UUID}/address`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body,
      }),
    }),

    // GET Contact
    getContact: builder.query({
      query: ({ UUID, token }) => ({
        url: `${VENDOR_REST_API}/${UUID}/contact`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    // POST Contact
    postContact: builder.mutation({
      query: ({ UUID, token, body }) => ({
        url: `${VENDOR_REST_API}/${UUID}/contact`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body,
      }),
    }),

    // GET Financial Details
    getFinancialDetails: builder.query({
      query: ({ UUID, token }) => ({
        url: `${VENDOR_REST_API}/${UUID}/financial`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    // POST Financial Details
    postFinancialDetails: builder.mutation({
      query: ({ UUID, token, body }) => ({
        url: `${VENDOR_REST_API}/${UUID}/financial`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body,
      }),
    }),

    //  getDropDownGroup: builder.query({
    //     query: ({ token }) => ({
    //       url: `${GET_DROPDOWN_GROUPS_AND_VALUES}`,
    //       method: "GET",
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     }),
    //   }),

    getDropDownGroup: builder.query({
      query: ({ token }) => {
        const userToken = getUserToken();
        return {
          url: `${GET_DROPDOWN_GROUPS_AND_VALUES}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    getDropDownGroupValues: builder.query({
      query: ({ payload: { field_name } }) => {
        return {
          url: `${GET_DROPDOWN_GROUPS_AND_VALUES}/values?field_name=${field_name}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),
    getVendorHeaders: builder.query({
      query: () => {
        const userToken = getUserToken();
        return {
          url: `${GET_VENDOR_HEADER_CONFIGURATION}?key=z_vendors`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${userToken}`,
            "content-type": "application/json",
          },
        };
      },
    }),
    getVendorHeadersValues: builder.query({
      query: () => {
        const userToken = getUserToken();
        return {
          url: `${GET_VENDOR_HEADER_CONFIGURATION_VALUES}?key=z_vendors`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${userToken}`,
            "content-type": "application/json",
          },
        };
      },
    }),
  }),
});

export const {
  useGetVendorByIdQuery,
  useGetGeneralInfoQuery,
  usePostGeneralInfoMutation,
  useGetAddressQuery,
  useLazyGetAddressQuery,
  usePostAddressMutation,
  useGetContactQuery,
  usePostContactMutation,
  useGetFinancialDetailsQuery,
  usePostFinancialDetailsMutation,
  useGetDropDownGroupQuery,
  useGetDropDownGroupValuesQuery,
  useLazyGetDropDownGroupValuesQuery,
  useGetVendorHeadersQuery,
  useGetVendorHeadersValuesQuery,
} = VendorsAPI;

export const customerGroup = createApi({
  reducerPath: "customerGroup",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCustomerGroup: builder.query({
      query: ({ token, company_id }) => ({
        url: `${GET_CUSTOMER_GROUP_DATA_ADD_UPDATE_TIME1}?company_id=${company_id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),
    fetchCustomerDashboard: builder.query({
      query: ({ token, customer_id }) => ({
        url: `${GET_CUS_DASH_DATA}${customer_id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),
  }),
});

// export const deleteTableCategoriesData = createApi({
//   reducerPath: 'customerGroup',
//   baseQuery: customBaseQuery,
//   endpoints: (builder) => ({
//     fetchCustomerGroup: builder.query({
//       query: ({ token, data }) => ({
//         url: `${DELETE_TABLE_CATEGORIES_DATA}`,
//         method: 'POST',
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       }),
//     }),
//   }),
// });

export const deleteTableCategoriesData = createApi({
  reducerPath: "dynamicDataTableDeleteData",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchDynamicDataTableData: builder.query({
      query: ({ token, data }) => ({
        url: `${DELETE_TABLE_CATEGORIES_DATA}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});

export const { deleteCustomerGroup } = deleteTableCategoriesData;

export const { useFetchCustomerGroupQuery, useFetchCustomerDashboardQuery } = customerGroup;
